import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Warning, X } from '@phosphor-icons/react';
import { useBranch } from '../contexts/BranchContext';
import api from '../utils/api';

const SubscriptionBanner = () => {
  const { activeBranch } = useBranch();
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (activeBranch?.branch_id) {
      fetchSubscriptionStatus();
    }
  }, [activeBranch?.branch_id]);

  const fetchSubscriptionStatus = async () => {
    try {
      const response = await api.get(`/billing/subscription/status/${activeBranch.branch_id}`);
      setSubscriptionStatus(response.data);
    } catch (error) {
      console.error('Failed to fetch subscription status:', error);
    }
  };

  if (dismissed || !subscriptionStatus || !subscriptionStatus.subscription_required) {
    return null;
  }

  const showWarning = subscriptionStatus.subscription_status === 'grace_period' || 
                      (subscriptionStatus.subscription_status === 'active' && subscriptionStatus.days_remaining <= 7);

  if (!showWarning) {
    return null;
  }

  const isGracePeriod = subscriptionStatus.subscription_status === 'grace_period';

  return (
    <div className={`${isGracePeriod ? 'bg-red-50 border-red-200' : 'bg-yellow-50 border-yellow-200'} border-b px-4 py-3`}>
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <Warning size={24} weight="fill" className={isGracePeriod ? 'text-red-600' : 'text-yellow-600'} />
          <div>
            <p className={`text-sm font-medium ${isGracePeriod ? 'text-red-800' : 'text-yellow-800'}`}>
              {isGracePeriod ? (
                <>
                  Your subscription has expired! You have {subscriptionStatus.grace_days_remaining} day{subscriptionStatus.grace_days_remaining !== 1 ? 's' : ''} of grace period remaining.
                </>
              ) : (
                <>
                  Your subscription expires in {subscriptionStatus.days_remaining} day{subscriptionStatus.days_remaining !== 1 ? 's' : ''}.
                </>
              )}
            </p>
            <p className={`text-xs ${isGracePeriod ? 'text-red-700' : 'text-yellow-700'} mt-0.5`}>
              {isGracePeriod ? 'Renew now to avoid losing access to the app.' : 'Renew soon to continue without interruption.'}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Link to="/subscription">
            <button className={`px-4 py-2 text-sm font-medium text-white rounded-lg transition-colors ${
              isGracePeriod 
                ? 'bg-red-600 hover:bg-red-700' 
                : 'bg-yellow-600 hover:bg-yellow-700'
            }`}>
              Renew Now
            </button>
          </Link>
          {!isGracePeriod && (
            <button
              onClick={() => setDismissed(true)}
              className="p-1 text-yellow-600 hover:text-yellow-800 transition-colors"
            >
              <X size={20} weight="bold" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionBanner;
